(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiredc87"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiredc87"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("6TJWq", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $505b8421e380ecc6$export$6503ec6e8aabbaf; }, function (v) { return $505b8421e380ecc6$export$6503ec6e8aabbaf = v; });
var $505b8421e380ecc6$export$6503ec6e8aabbaf;
var $505b8421e380ecc6$export$f7ad0328861e2f03;
"use strict";
var $505b8421e380ecc6$var$mapping = new Map();
function $505b8421e380ecc6$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$505b8421e380ecc6$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $505b8421e380ecc6$var$resolve(id) {
    var resolved = $505b8421e380ecc6$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$505b8421e380ecc6$export$6503ec6e8aabbaf = $505b8421e380ecc6$var$register;
$505b8421e380ecc6$export$f7ad0328861e2f03 = $505b8421e380ecc6$var$resolve;

});

parcelRegister("lpwGa", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $f965482ec7a35662$export$bdfd709ae4826697; }, function (v) { return $f965482ec7a35662$export$bdfd709ae4826697 = v; });
var $f965482ec7a35662$export$bdfd709ae4826697;
var $f965482ec7a35662$export$c9e73fbda7da57b6;
var $f965482ec7a35662$export$5a759dc7a1cfb72a;
"use strict";
var $f965482ec7a35662$var$bundleURL = {};
function $f965482ec7a35662$var$getBundleURLCached(id) {
    var value = $f965482ec7a35662$var$bundleURL[id];
    if (!value) {
        value = $f965482ec7a35662$var$getBundleURL();
        $f965482ec7a35662$var$bundleURL[id] = value;
    }
    return value;
}
function $f965482ec7a35662$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $f965482ec7a35662$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $f965482ec7a35662$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $f965482ec7a35662$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$f965482ec7a35662$export$bdfd709ae4826697 = $f965482ec7a35662$var$getBundleURLCached;
$f965482ec7a35662$export$c9e73fbda7da57b6 = $f965482ec7a35662$var$getBaseURL;
$f965482ec7a35662$export$5a759dc7a1cfb72a = $f965482ec7a35662$var$getOrigin;

});

var $ee382aeb3fe63482$exports = {};


(parcelRequire("6TJWq")).register((parcelRequire("lpwGa")).getBundleURL("88FtB"), JSON.parse('["88FtB","index.8292cd79.js","051d2","zusam_logo.1eebfd28.svg"]'));

})();
//# sourceMappingURL=index.runtime.096eed7d.js.map
